/**
 * @generated SignedSource<<3c48abcc6b496304054e100d2e441e9b>>
 * @relayHash cf384c20d02578de5057af63fc8ffcd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7dec10e76f05bd66b0bce134e788f44487f264e251120bb3271f6f78d1bec90e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualServiceAgentCtaCardQuery } from './VirtualServiceAgentCtaCardQuery.graphql';

const node: PreloadableConcreteRequest<VirtualServiceAgentCtaCardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7dec10e76f05bd66b0bce134e788f44487f264e251120bb3271f6f78d1bec90e",
    "metadata": {},
    "name": "VirtualServiceAgentCtaCardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
